import React from 'react';
import { useApp } from '../../../context/AppContext';
import PublisherDashboardPage from '../../publishers/PublisherDashboardPage';
import TEODashboardPage from './TEODashboardPage';
import TODashboardPage from './TODashboardPage';
import PODashboardPage from './PODashboardPage';
import PEODashboardPage from './PEODashboardPage';
import { FaUsers, FaMapMarkerAlt, FaSchool, FaUserGraduate } from 'react-icons/fa';
import { DashboardChartGrid } from '../../../components_shared/PortalDashboard';

function DashboardPage() {
  const { user, roles } = useApp();
  if (roles){
    if(roles.includes('ROLE_PUBLISHER')) return <PublisherDashboardPage/>;
    if(roles.includes('ROLE_TEO')) return <TEODashboardPage/>;
    if(roles.includes('ROLE_TO'))  return <TODashboardPage/>;
    if(roles.includes('ROLE_PO'))  return <PODashboardPage/>;
    if(roles.includes('ROLE_PEO')) return <PEODashboardPage/>;
  }
  // Example summary data (replace with real API data as needed)
  const summary = [
    { icon: <FaUsers />, label: 'Users', value: 120, className: 'eduss-dashboard-card-blue' },
    { icon: <FaMapMarkerAlt />, label: 'Regions', value: 18, className: 'eduss-dashboard-card-green' },
    { icon: <FaSchool />, label: 'Schools', value: 250, className: 'eduss-dashboard-card-yellow' },
    { icon: <FaUserGraduate />, label: 'Students', value: 3200, className: 'eduss-dashboard-card-green' },
  ];
  const chartRows = summary.map(item => ({ name: item.label, value: item.value }));

  return (
    <div className="eduss-dashboard">
        <div className="eduss-dashboard-welcome">
          <h1>Welcome, {user?.username || 'User'}!</h1>
          <p>This is your dashboard. Quick stats and recent activity will appear here.</p>
        </div>
        <div className="eduss-dashboard-cards-row">
          {summary.map(item => (
            <div className={`eduss-dashboard-card ${item.className}`} key={item.label}>
              <div className="eduss-dashboard-card-icon">{item.icon}</div>
              <div className="eduss-dashboard-card-content">
                <div className="eduss-dashboard-card-label">{item.label}</div>
                <div className="eduss-dashboard-card-value">{item.value}</div>
                <div className="eduss-dashboard-card-desc">Total {item.label.toLowerCase()}</div>
              </div>
            </div>
          ))}
        </div>
        <DashboardChartGrid charts={[
          { title: 'System Overview', caption: 'Core records', type: 'bar', data: chartRows, color: '#0f6fad' },
          { title: 'Activity Trend', caption: 'Snapshot', type: 'line', data: chartRows, color: '#10ac84' },
        ]} />
        {/* Placeholder for recent activity or quick stats */}
        <div className="eduss-dashboard-content">
          <h2>Recent Activity</h2>
          <p>No recent activity to show yet.</p>
        </div>
      </div>
  );
}

export default DashboardPage;
